import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-white/[0.06] bg-canvas-black">
      <div className="container-prose py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo size={28} />
            <p className="mt-5 text-[14px] leading-relaxed text-ink-faint max-w-sm">
              Trade booking automation for commodity desks. Built for the GCC — Qatar,
              Saudi Arabia and the wider Gulf — and the realities of how trades actually
              get confirmed.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber/10 ring-1 ring-amber/25">
              <span className="w-1.5 h-1.5 rounded-full bg-amber animate-pulse-soft" />
              <span className="text-[11.5px] font-medium tracking-wide uppercase text-amber-light">
                Launching H2 2026
              </span>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[11px] font-semibold tracking-[0.12em] uppercase text-ink-faint mb-4">
              Product
            </h4>
            <ul className="space-y-2.5 text-[14px] text-ink-faint">
              <li><Link to="/product" className="hover:text-canvas-white">Overview</Link></li>
              <li><Link to="/security" className="hover:text-canvas-white">Security</Link></li>
              <li><Link to="/request-demo" className="hover:text-canvas-white">Request access</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[11px] font-semibold tracking-[0.12em] uppercase text-ink-faint mb-4">
              Company
            </h4>
            <ul className="space-y-2.5 text-[14px] text-ink-faint">
              <li><Link to="/request-demo" className="hover:text-canvas-white">Contact</Link></li>
              <li><a href="mailto:hello@coretrade.ai" className="hover:text-canvas-white">hello@coretrade.ai</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] font-semibold tracking-[0.12em] uppercase text-ink-faint mb-4">
              Connect
            </h4>
            <div className="flex items-center gap-3">
              <a
                href="mailto:hello@coretrade.ai"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-ink-faint hover:text-canvas-white hover:border-white/25 transition-colors"
                aria-label="Email"
              >
                <Mail size={15} />
              </a>
              <a
                href="https://linkedin.com"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-ink-faint hover:text-canvas-white hover:border-white/25 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={15} />
              </a>
            </div>
            <p className="mt-5 text-[12px] text-ink-faint/70 leading-relaxed">
              hello@coretrade.ai
            </p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/[0.06] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[12px] text-ink-faint/70">
            © {year} Core Trade. All rights reserved.
          </p>
          <p className="text-[11px] font-mono text-ink-faint/60 tracking-wide">
            coretrade.ai
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
